import React from 'react';
import { makeStyles } from '@mui/styles';
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import axios from '../../utils/axiosConfig';
const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
  },
  paper: {
    backgroundColor: "#ffffff",
    padding: theme.spacing(2, 4, 3),
    borderRadius : "15px",
    position: 'relative',
    outline: 'none',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)'
  }
}));

const PopOverPopUpState = (props) => {
  const classes = useStyles();
  const { testData, setQuestionNo, questionNo, setQuestionChange, navFlag } = props;

  const _questionClicked = (questionNumber) => {

    setQuestionNo(questionNumber);
    setQuestionChange(true);
    //setQuestion()
  }
  const [anchorEl, setAnchorEl] = React.useState("false");
  const [issueDescription, setIssueDescription] = React.useState('');
  const [selectedValue, setSelectedValue] = React.useState('');

  const handleChangeRadio = (event) => {
    setSelectedValue(event.target.value);
  };

  const controlProps = (item) => ({
    checked: selectedValue === item,
    onChange: handleChangeRadio,
    value: item,
    name: 'color-radio-button',
    inputProps: { 'aria-label': item },
  });

  const handleClick = () => {
    setAnchorEl("true");
    const mainBody = document.getElementById("main-body");
    if (mainBody) {
      mainBody.style.overflow = 'hidden';
    }
  };

  const handleClose = () => {
    setAnchorEl("false");
    const mainBody = document.getElementById("main-body");
    if (mainBody) {
      mainBody.style.overflow = '';
    }
    setSelectedValue('')
    setIssueDescription('')
  };

  const handleChange = (e) => {
    setIssueDescription(e.target.value);
  }

  const handleCancel = (_e) => {
    setIssueDescription('');
    setSelectedValue('');
  }

  const reportIssue = () => {
    axios.post('/test/questionIssues', {
      headers: {
        'Access-Control-Allow-Origin': '*',
      }, qid: testData[questionNo - 1].qid, issuetype: selectedValue, description: issueDescription
    // eslint-disable-next-line unused-imports/no-unused-vars
    }).then(resp => {

    }).catch(err => {
      console.log('questionIssues error:', err);
    })
    setAnchorEl("false");
    const mainBody = document.getElementById("main-body");
    if (mainBody) {
      mainBody.style.overflow = '';
    }
    setIssueDescription('');
    setSelectedValue('');
  }

  const open = Boolean(anchorEl);
  const _id = open ? 'simple-popover' : undefined;
  return (
    <>
      {
        anchorEl === "false" ?
          <div className="flag-text">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" disabled={!navFlag} style={{ color: "#6D75D8" }} onClick={handleClick}><p>Flag this question</p></a>
          </div>
          : <div className="flag-text">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" disabled={!navFlag} style={{ color: "#6D75D8" }} onClick={handleClose}><p>Flag this question</p></a>
          </div>
      }

      {
        anchorEl === "true" ?
          <Modal
            disableEnforceFocus = {true}
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={anchorEl}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
            PaperProps={{
              style: {
                backgroundColor: "#e5e5e9"
              }
            }}
          >
            <Fade in={anchorEl}>
              {/* <div className={classes.paper}> */}
              <div className={classes.paper}>
                <div className='row' style={{ display: 'flex' }} ><h2 style={{ color: "#b45e9b" }}>Report Issue</h2>
                  <h2 style={{ color: "#b45e9b", marginLeft: "auto", cursor: "pointer" }} onClick={(e) => handleClose(e)}>x</h2></div>
                <div className="card-body row">

                  <div className="todo-list col-md-6">
                    <h4>Please select issue type from below option</h4>
                    <div className="todo-item">
                      <div className="checker"><span className=""><input type="radio" value='1' name='Grammatical or Pharasing Error' {...controlProps('Grammatical or Pharasing Error')} /></span></div>
                      <span>&nbsp;&nbsp;Grammatical or Pharasing Error</span>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                      <a href="javascript:void(0);" className="float-right remove-todo-item"><i className="icon-close"></i></a>
                    </div>
                    <div className="todo-item">
                      <div className="checker"><span className=""><input type="radio" value='2' name='Two or more correct answer' {...controlProps('Two or more correct answer')} /></span></div>
                      <span>&nbsp;&nbsp;Two or more correct answer</span>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                      <a href="javascript:void(0);" className="float-right remove-todo-item"><i className="icon-close"></i></a>
                    </div>

                    <div className="todo-item">
                      <div className="checker"><span className=""><input type="radio" {...controlProps('No correct answer')} /></span></div>
                      <span>&nbsp;&nbsp;No correct answer</span>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                      <a href="javascript:void(0);" className="float-right remove-todo-item"><i className="icon-close"></i></a>
                    </div>
                    <div className="todo-item">
                      <div className="checker"><span><input type="radio" {...controlProps('Outdated Question')} /></span></div>
                      <span>&nbsp;&nbsp;Outdated Question</span>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                      <a href="javascript:void(0);" className="float-right remove-todo-item"><i className="icon-close"></i></a>
                    </div>
                    <div className="todo-item">
                      <div className="checker"><span><input type="radio" {...controlProps('Irrelevent Question')} /></span></div>
                      <span>&nbsp;&nbsp;Irrelevent Question</span>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                      <a href="javascript:void(0);" className="float-right remove-todo-item"><i className="icon-close"></i></a>
                    </div><div className="todo-item">
                      <div className="checker"><span><input type="radio" {...controlProps('Other')} /></span></div>
                      <span>&nbsp;&nbsp;Other</span>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                      <a href="javascript:void(0);" className="float-right remove-todo-item"><i className="icon-close"></i></a>
                    </div>
                  </div>
                  <div className="todo-list col-md-6">
                    <h4>Please give additional detail about the issue </h4>
                    <div className="form-group">
                      <textarea className="form-control" id="exampleFormControlTextarea1" rows="10" value={issueDescription} onChange={(e) => handleChange(e)}></textarea>
                    </div>
                    <div className="form-group">
                      <ul className="list-inline btn-list">
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <li><a href="#" className="btn btn-blue" disabled={selectedValue === '' || issueDescription === ''} onClick={(e) => reportIssue(e)} >
                          <strong>Report Issue</strong>
                        </a></li>
                        <li>
                          <a className="btn" style={{color:'#000', background:'#dbdbdb', borderColor:'#dbdbdb'}} {...controlProps('')} onClick={(e) => handleCancel(e)} >
                            <strong>Reset</strong>
                          </a></li>
                        {/* <li><a className="btn btn-blue" {...controlProps('')} onClick={handleClose} >
                          <strong>Close</strong>
                        </a></li> */}
                      </ul></div>
                  </div>
                </div>

              </div>
            </Fade>
          </Modal> : <></>}

    </>
  );
}
export default PopOverPopUpState;
